// extracted by mini-css-extract-plugin
export default {"root":"lf1R6CPB","active":"rVV4tcO8","icon":"tolJKrT2"};